import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import AddReviewButton from 'components/AddReviewButton';
import UpgradeAccountButton from 'scenes/Sidebar/components/ActionButtonsWidget/components/UpgradeAccountButton';
import GatButton from 'scenes/Sidebar/components/ActionButtonsWidget/components/GatButton';
import CountdownTimer from 'components/CountdownTimer';

import { Permission, Role } from 'helpers/user';
import { ROUTE } from 'constants/route';

const ActionButtonsWidget = props => {
  const { user, history } = props;

  const [
    isVisibleAddInterviewReview,
    isVisibleAddEmployeeReview,
    isVisibleAddOverviewReview,
  ] = useMemo(() => {
    const isCandidate = Role.isCandidate(user);

    return [
      !isCandidate ||
        (isCandidate &&
          Permission.isAllowedAddInterviewReview(user.permissions)),
      !isCandidate ||
        (isCandidate &&
          Permission.isAllowedAddEmployeeReview(user.permissions)),
      !isCandidate ||
        (isCandidate &&
          Permission.isAllowedAddOverviewReview(user.permissions)),
    ];
  }, [user]);

  const handleClickAddReviewLink = e => {
    if (!Role.isCandidate(user, true)) {
      e.preventDefault();
    }
  };

  return (
    <>
      <div className="sidebar__panel">
        {user.reviewAccessExpireAt && (
          <CountdownTimer
            text="Full Review Profiles Access"
            expireDate={user.reviewAccessExpireAt}
          />
        )}
        {(isVisibleAddInterviewReview ||
          isVisibleAddEmployeeReview ||
          isVisibleAddOverviewReview) && (
          <>
            {isVisibleAddInterviewReview && (
              <AddReviewButton
                text="Add Interview Review"
                link={
                  isVisibleAddInterviewReview ? ROUTE.ADD_REVIEW_INTERVIEW : '#'
                }
                onClick={handleClickAddReviewLink}
              />
            )}
            {isVisibleAddEmployeeReview && (
              <AddReviewButton
                text="Add Employee Review"
                link={
                  isVisibleAddEmployeeReview ? ROUTE.ADD_REVIEW_EMPLOYEE : '#'
                }
                onClick={handleClickAddReviewLink}
              />
            )}
            {isVisibleAddOverviewReview && (
              <AddReviewButton
                text="Add Company Review"
                link={
                  isVisibleAddOverviewReview ? ROUTE.ADD_REVIEW_COMPANY : '#'
                }
                onClick={handleClickAddReviewLink}
              />
            )}
          </>
        )}
      </div>
      <div style={{ marginBottom: '15px' }}>
        <UpgradeAccountButton user={user} history={history} />
        <GatButton user={user} history={history} />
      </div>
    </>
  );
};

ActionButtonsWidget.propTypes = {
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default ActionButtonsWidget;
